import { Axios } from "../../service/serviceBasic";
import { toast } from "react-toastify";

import {
    LOADING_DDI,
    SET_LIST_PAIS,
    SET_DDI_FIXO_BRASIL
} from './types';

const setLoadingDdi = (flag) => ({
    type: LOADING_DDI,
    payload: flag,
});

const setListPais = (data) => ({
    type: SET_LIST_PAIS,
    payload: data,
});

const setDdiFixoBrasil = (flag) => ({
    type: SET_DDI_FIXO_BRASIL,
    payload: flag,
});

export const configuracaoDdi = () => async dispatch => {

  dispatch(setLoadingDdi(true));
  await getFlagDdi(dispatch);
  await listPais(dispatch);
  dispatch(setLoadingDdi(false));
}

const getFlagDdi = async dispatch => {
  return Axios.post("v2/basico/configuracaosistema/get", {IdConfiguracaoSistema: "DdiFixoBrasil"})
  .then(res => {
    dispatch(setDdiFixoBrasil(res.data.Valor === "true"));
  })
  .catch(() => {
    dispatch(setDdiFixoBrasil(true));     
  })
  .finally(() => {});
}

const listPais = async dispatch => {
  return Axios.post("v1/basico/pais/list", {})
  .then(result => {
    dispatch(setListPais(result.data));
  })
  .catch((error) => {
    dispatch(setDdiFixoBrasil(true));
  })
  .finally(() => {});
}